import { API } from 'aws-amplify'

import { CreateUpdateScoreDto, ScoreDto } from '../types/index'

export const getScores = async (): Promise<ScoreDto[]> => {
    return API.get('api', '/score', {})
}

export const getScoreByCardCollectionId = async (cardCollectionId: string): Promise<ScoreDto> => {
    return API.get('api', `/card-collection/${cardCollectionId}`, {})
}


export const createUpdateScore = async (scoreId: string, { score, progress, cardCollectionId, answers }: CreateUpdateScoreDto): Promise<ScoreDto> => {
    return API.put('api', `/score/${scoreId}`, { body: { score, progress, cardCollectionId, answers } })
}

export const deleteScore = async (scoreId: string): Promise<string> => {
    return API.del('api', `/score/${scoreId}`, {})
}